import $ from 'jquery';
import {
	getSupportedAnimationEndEvent,
	getSupportedTransitionEndEvent,
} from '../utils/supported-events';

const isElementInDOM = function( element ) {
	return $.contains( document.documentElement, element );
};

const Reveal = {
	SELECTORS: [ '[data-reveal]', '[class^="majik-reveal"]', '[class*=" majik-reveal"]' ],
	CHILD_SELECTORS: [ '[class^="majik-parent-reveal"]', '[class*=" majik-parent-reveal"]' ],
	$elements: $( [] ),
	addSelector: function( selector ) {
		if ( ! selector || ! selector.length || this.SELECTORS.indexOf( selector ) > -1 ) {
			return;
		}

		this.SELECTORS.push( selector );

		return this;
	},
	addChildSelector: function( selector ) {
		if ( ! selector || ! selector.length || this.CHILD_SELECTORS.indexOf( selector ) > -1 ) {
			return;
		}

		this.CHILD_SELECTORS.push( selector );

		return this;
	},
	add: function( $element, check = true ) {
		// If $element is not jQuery object then initialize it.
		if ( ! $element instanceof jQuery ) {
			$element = $( $element );
		}

		// Remove elements that are not in DOM.
		$element = $element.filter( ( index, element ) => isElementInDOM( element ) );

		// Check if element is empty.
		if ( ! $element.length ) {
			return;
		}

		this.$elements = this.$elements.add( $element.find( this.SELECTORS.join( ', ' ) ) );

		if ( check ) {
			// eslint-disable-next-line no-use-before-define
			checkIfInView();
		}

		return this;
	},
	filterElements: function( check = true ) {
		this.$elements = this.$elements.filter( ( index, element ) => isElementInDOM( element ) );

		if ( check ) {
			// eslint-disable-next-line no-use-before-define
			checkIfInView();
		}
	},
	isChild: function( el ) {
		const $el = $( el );
		const l = this.CHILD_SELECTORS.length;

		if ( l < 1 ) {
			return false;
		}

		let i;

		for ( i = 0; i < l; i++ ) {
			if ( $el.is( this.CHILD_SELECTORS[ i ] ) ) {
				return true;
			}
		}

		return false;
	},
};

const handleOnAnimationEnd = function() {
	const $self = $( this );
	let removeOnAnimationEnd = $self
		.attr( 'data-reveal-remove-on-animation-end' );

	if ( removeOnAnimationEnd ) {
		removeOnAnimationEnd = removeOnAnimationEnd.split( ' ' );
	}

	let addOnAnimationEnd = $self
		.attr( 'data-reveal-add-on-animation-end' );

	if ( addOnAnimationEnd ) {
		addOnAnimationEnd = addOnAnimationEnd.split( ' ' );
	}

	if ( removeOnAnimationEnd && removeOnAnimationEnd.length ) {
		const length = removeOnAnimationEnd.length;
		let i;

		for ( i = 0; i < length; i++ ) {
			$self.removeClass( removeOnAnimationEnd[ i ] );
		}
	}

	if ( addOnAnimationEnd && addOnAnimationEnd.length ) {
		const length = addOnAnimationEnd.length;
		let i;

		for ( i = 0; i < length; i++ ) {
			$self.addClass( addOnAnimationEnd[ i ] );
		}
	}
};

const handleOnTransitionEnd = function() {
	const $self = $( this );
	let removeOnTransitionEnd = $self
		.attr( 'data-reveal-remove-on-transition-end' );

	if ( removeOnTransitionEnd ) {
		removeOnTransitionEnd = removeOnTransitionEnd.split( ' ' );
	}

	let addOnTransitionEnd = $self
		.attr( 'data-reveal-add-on-transition-end' );

	if ( addOnTransitionEnd ) {
		addOnTransitionEnd = addOnTransitionEnd.split( ' ' );
	}

	if ( removeOnTransitionEnd && removeOnTransitionEnd.length ) {
		const length = removeOnTransitionEnd.length;
		let i;

		for ( i = 0; i < length; i++ ) {
			$self.removeClass( removeOnTransitionEnd[ i ] );
		}
	}

	if ( addOnTransitionEnd && addOnTransitionEnd.length ) {
		const length = addOnTransitionEnd.length;
		let i;

		for ( i = 0; i < length; i++ ) {
			$self.addClass( addOnTransitionEnd[ i ] );
		}
	}
};

let startTime = null;
let doingCheck = false;

const _checkIfInView = function( timestamp ) {
	doingCheck = false;

	if ( null === startTime ) {
		startTime = timestamp;
	}

	if ( ! Reveal.$elements.length ) {
		return;
	}

	if ( ( timestamp - startTime ) < 300 ) {
		// eslint-disable-next-line no-use-before-define
		checkIfInView();

		return;
	}

	const windowHeight = $( window ).height();
	const windowPositionTop = $( window ).scrollTop();
	const windowPositionBottom = windowPositionTop + windowHeight;

	Reveal.$elements = Reveal.$elements.filter( function() {
		const $self = $( this );

		const elementHeight = $self.outerHeight();
		let elementPositionTop = parseFloat( $self.offset().top );
		let elementPositionBottom = parseFloat( elementHeight + elementPositionTop );
		const elementTopOffset = $self.attr( 'data-reveal-offset' );

		if ( elementTopOffset ) {
			elementPositionTop -= parseFloat( elementTopOffset );
			elementPositionBottom += parseFloat( elementTopOffset );
		}

		if (
			(
				elementPositionTop >= windowPositionTop &&
				elementPositionTop <= windowPositionBottom
			) ||
			(
				elementPositionBottom >= windowPositionTop &&
				elementPositionBottom <= windowPositionBottom
			) || (
				elementPositionTop <= windowPositionTop &&
				elementPositionBottom >= windowPositionBottom
			)
		) {
			$self
				.one( getSupportedAnimationEndEvent(), handleOnAnimationEnd )
				.one( getSupportedTransitionEndEvent(), handleOnTransitionEnd );

			$self
				.find( '[class^="majik-parent-reveal"], [class*=" majik-parent-reveal"]' )
				.one( getSupportedAnimationEndEvent(), handleOnAnimationEnd )
				.one( getSupportedTransitionEndEvent(), handleOnTransitionEnd );

			$self.addClass( 'in-view' );

			if ( 'true' === $self.attr( 'data-reveal-trigger-event' ) ) {
				$self.trigger( 'majik.reveal.inView' );
			}

			return false;
		}

		return true;
	} );
};

// Reveal animations
const checkIfInView = function() {
	if ( doingCheck ) {
		return;
	}

	doingCheck = true;
	requestAnimationFrame( _checkIfInView );
};

Reveal.add( $( 'body' ), false );

$( window ).on(
	'scroll.checkIfInView resize.checkIfInView sj.fontLoad.loaded sj.fontLoad.failed',
	checkIfInView
);
checkIfInView();

// Hover effects.
$( document )
	.on(
		'mouseenter',
		[
			'[class^="majik-hover"]:not(.hover)',
			'[class*=" majik-hover"]:not(.hover)'
		].join( ', ' ),
		function() {
			$( this )
				.one(
					getSupportedAnimationEndEvent() +
					' ' +
					getSupportedTransitionEndEvent(),
					function( event ) {
						$( event.target ).removeClass( 'hover' );
					}
				)
				.addClass( 'hover' );
		}
	);

export default Reveal;
export {
	checkIfInView,
};
